export const LOADING_DOTS = 'loading-dots'
